import { $el } from 'src/scripts/utils/utils'
import { BaseComponent } from '../base-component'

const CONTENT_SELECTOR = '[data-tabs-element-content]'

export class TabWithDynamicHeight extends BaseComponent {
  resizeObserver: ResizeObserver

  mountComponent(): void {
    const content = $el(CONTENT_SELECTOR, this)

    this.resizeObserver = new ResizeObserver(this.handleResize)
    this.resizeObserver.observe(content)

    this.updateHeight()
  }

  unmountComponent(): void {
    this.resizeObserver.disconnect()
  }

  handleResize = (): void => {
    this.updateHeight()
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this.updateHeight()
  }

  async show(): Promise<void> {
    this.setVisible(true)
  }

  async hide(): Promise<void> {
    this.setVisible(false)
  }

  setVisible(isVisible: boolean): void {
    this.setAttribute('aria-hidden', isVisible ? 'false' : 'true')
  }

  updateHeight(): void {
    const content = $el(CONTENT_SELECTOR, this)

    if (!content) {
      return
    }

    this.style.maxHeight = `${Math.ceil(
      this.isVisible ? content.offsetHeight : 0,
    )}px`
  }

  get isVisible(): boolean {
    return this.getAttribute('aria-hidden') === 'false'
  }

  static get observedAttributes() {
    return ['aria-hidden']
  }
}
